import React from 'react';
import Scene from './components/Scene';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Pack from './components/Pack';
import About from './components/About';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <>
      <Scene />
      <Nav />
      <main>
        <Hero />
        <Experience />
        <Projects />
        <Pack />
        <About />
      </main>
      <Footer />
    </>
  );
}

export default App;
